$(document).ready(function($) {
    if (! $('#taskboard-stages').length) return;

    window.pipelineView = {};
    window.pipelineView.currentPage = 1;
    window.pipelineLastClicked = 0;

    window.initPipeline = function(){
        $('#filter').trigger('submit');
        initSortablePipeline();
    }

    window.pipelineView.updateLink = $('#filter-result').data('update');
    window.pipelineView.activityLink = $('#filter-result').data('activity');

    initPipeline();

    $('body').on('activity:added', function(){
        // console.log('activity:added we should update '+window.pipelineLastClicked);
        updatePipelineItem(window.pipelineLastClicked, 0);
    });

    $('#show_more').on('click', function(){
        var next = window.pipelineView.currentPage+1;
        $('#filter').trigger('filter:pagechange');
        var $input = $('input[name=page]').first();
        $input.val(next);
        $input.trigger("change");
    });

    function initSortablePipeline(){

        $('.list-group').sortable({
            connectWith: ".drop-group",
            dropOnEmpty: true,
            items: '.list-group-item.editable',
            start: function( event, ui ){
                initialStatus = ui.item.parent().data('status-pipeline');
                initialSender = ui.item.parent();
            },
            stop: function( event, ui ) {
                // $('#win-loss').removeClass('inplace');
                var obj = ui.item;
                var obj_id = obj.data('id');
                var new_pipeline_status = obj.parent().data('status-pipeline');

                if (initialStatus != new_pipeline_status){
                    var that = self;
                    updatePipelineItem(obj_id, new_pipeline_status);
                }
            },

            receive: function(event, ui){

            }
        })

            .mousedown(function(){
                $('#win-loss').addClass('inplace');
            }).
            mouseup(function(){
                $('#win-loss').removeClass('inplace');
            });
    }


    var clearPipelineStages = function(){
        $('.taskboard-list').each(function(){
            $(this).html('');
        });
    }

    var addItemToStage = function(item){
        var template = taskTemplate(item);
        var $container = $('#stagecontent_'+item.status_pipeline);
        $container.append(template);
    }

    var updateItemToStage = function(item){
        var template = taskTemplate(item);
        $('#item-'+item.id).replaceWith(template);
    }

    var updatePipelineItem = function(id, status){
        stageSameHeight();
        $.post(window.pipelineView.updateLink, {id:id, status: status})
            .done(function(data){
                if (data.item != undefined)
                    updateItemToStage(data.item);
                updateStageAmounts(data);
                stageSameHeight();
            });
    }

    var updateStageAmounts = function(data){
        $('.stage-amount').html('');
        if (data.amounts != undefined){
            for(var i=0; i< data.amounts.items.length; i++){
                var item = data.amounts.items[i];
                if (item.amount!=0)
                    $('#'+item.stage_status+' .stage-amount').html(data.amounts.currency+' '+item.amount);
            }
        }
    }

    window.pipelineDataHandler = function(data){

        var list = [];
        if (data.items.currentPage == 1){
            clearPipelineStages();
        }

        window.pipelineView.currentPage = data.items.currentPage;

        if (data.items.hasMorePages){
            $('#show_more').removeClass('hidden');
        }else{
            $('#show_more').addClass('hidden');
        }

        for (var i = 0; i < data.items.data.length; i++) {
            var item = data.items.data[i];
            addItemToStage(item);
        }

        updateStageAmounts(data);
        stageSameHeight();
    }


    var stageSameHeight = function(){

        var highestBox = 0;
        var $list =$('#filter-result .list-group');
        $list.css('min-height',0);
        // Select and loop the elements you want to equalise
        $list.each(function(){

            // If this box is higher than the cached highest then store it
            if($(this).height() > highestBox) {
                highestBox = $(this).height();
            }

        });

        // Set the height of all those children to whichever was highest
        $list.css('min-height', highestBox);
    }

    $(document).on('click','#taskboard-stages [data-toggle=slidePanel]', function(e) {

        if ($(this).data('id') != undefined) {
            window.pipelineLastClicked  = $(this).data('id');
            return;
        }
        window.pipelineLastClicked = $(this).parent().parent().data('id');
    });

    var taskTemplate = function(data){
        return '<li id="item-'+data.id+'" class="list-group-item '+data.edit+' priority-' + data.priority + '" data-toggle="slidePanel" data-url="'+data.linkslidepanel+'" data-id="' + data.id + '">' +
            '<div>' +
            '<div class="avatar">'+ data.image+'</div>'+
            '<label class="task-title">' + data.name + '</label>' +
                //'<span class="time">3 days ago</span>' +
            '</div>' +
            '<div class="task-badges" data-toggle="slidePanel" data-url="'+data.linkslidepanel+'?tab=activities"></div>' +
            buildBadges(data)+
            '<div class="task-action">' +
            '<btn type="button" class="btn btn-icon btn-success btn-sm btn-sm btn-round btn-outline" data-url="'+window.pipelineView.activityLink+data.id+'" data-toggle="slidePanel" data-tooltip="true" data-placement="top" data-original-title="Adauga activitate"><i class="ti-plus" aria-hidden="true"></i></btn>'+
            '</div>' +
            '</div>' +
            '</li>';
    }

    var buildBadges = function(data){
        var html = '';
        $.each(data.activities, function(n, activity){
            html += badgeTemplate(activity);
        });
        return html;
    }

    var badgeTemplate = function(activity){
        var html = '';

        html = '<span class="task-badge task-badge-subtask icon '+activity.icon+' activity-statuskey-'+activity.statuskey+'">' + activity.notcompleted + '</span>';

        return html;
    }

});



